<template>
  <div>
    <div class="header">
      <h2>Submissions</h2>
      <SubmitOrder>
        <button class="btn btn-dark btn-block btn-add" id="submitOrderButton">
          <span>Submit Order</span><span class="plusIcon">&#65291;</span>
        </button>
      </SubmitOrder>
    </div>
    <div class="description">
      View status of your submitted orders below. Submissions will move to
      'Order History' when released to production.
    </div>
    <BBDataTable
      class="submissionsContainer"
      :columns="columns"
      :support-add-new="false"
      path-url-api="orders"
      :default-api-params="{
        _view: 'submissions',
        _fields:
          'orderNumber,createdAt,currentStatus.name,currentStatus.status',
        _fieldsNoPopulate:
          'design._id,design.name,design.thumbnailSmallCenterPath,design.product.productCategory.name,design.bodyColor,design.quantity,design.product.gender.name,currentStatus.name,reorderChild,isReorder,cannotReorder,design.overrideValidationMinimum',
        _sort: 'createdAt',
        _order: 'desc',
        _filter: [
          {
            field: 'isDeleted',
            op: '=',
            val: 'false'
          },
          {
            field: 'user',
            op: '=',
            val: userId
          },
          {
            field: 'currentStatus',
            op: 'nin',
            val: [
              this.orderStatusOrderOrderInProgress,
              this.orderStatusOrderOrderShipped,
              this.orderStatusOrderOrderLegacy,
              this.orderStatusOrderOrderCancelled,
              this.orderStatusOrderReorderInProgress
            ]
          }
        ]
      }"
    >
      <template v-slot:customCell="{ props }">
        <div v-if="props.column.field == 'orderNumber'" class="orderNumberCell">
          <div class="boldText">
            {{ formatOrderNumber(props.row.orderNumber) }}
          </div>
          <div class="imgSubmission">
            <b-img-lazy
              :src="props.row.design.thumbnailSmallCenterPath"
              v-if="props.row.design.thumbnailSmallCenterPath"
              v-bind="imgSubmission"
            />
            <span v-else>No image</span>
          </div>
        </div>
        <div
          v-else-if="props.column.field == 'currentStatus'"
          class="currentStatusCell"
        >
          <div class="boldText">
            <div v-if="[1, 4, 7].includes(props.row.currentStatus.status)">
              Rep Review
            </div>
            <div
              v-else-if="
                [3, 5, 6, 13, 14, 27].includes(props.row.currentStatus.status)
              "
            >
              Adidas Review
            </div>
            <div v-else-if="[2].includes(props.row.currentStatus.status)">
              Needs Review
            </div>
          </div>
        </div>
        <div v-else>
          {{ props.formattedRow[props.column.field] }}
        </div>
      </template>

      <template v-slot:customButtons="slotProps">
        <div class="actions d-flex flex-wrap" style="width:120px;">
          <button
            class="btn btn-link btn-highlight btn-sm ml-2"
            @click="viewOrder(slotProps.props.row)"
          >
            <font-awesome-icon class="mr-2" :icon="icons.faEye" />
            <span class="bb-label">VIEW</span>
          </button>
        </div>
      </template>
    </BBDataTable>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { faEye, faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import SubmitOrder from '@/components/Front/locker/SubmitOrder'

const oauthStore = namespace('oauthStore')
const userStore = namespace('userStore')

@Component({
  components: { SubmitOrder }
})
export default class Submissions extends Vue {
  @oauthStore.Getter('userId') userId
  @userStore.Action('setIsReorder') actionSetIsReorder
  @userStore.Action('setOverrideValidationMinimum')
  actionSetOverrideValidationMinimum
  icons = {
    faEye,
    faPencilAlt
  }

  viewOrder(order) {
    if (order.design && order.design.overrideValidationMinimum) {
      this.actionSetOverrideValidationMinimum(
        order.design.overrideValidationMinimum
      )
    }
    this.$router.push({
      name: 'orderReview',
      params: {
        id: order.design._id,
        orderId: order._id
      }
    })
  }

  get columns() {
    return [
      {
        label: 'ID',
        field: '_id',
        hidden: true
      },
      {
        label: 'Submission',
        field: 'orderNumber',
        type: 'customCell',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by Order Number', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          operator: '=',
          trigger: 'keyup' // only trigger on enter not on keyup
        }
      },
      {
        label: 'Design Name',
        field: 'design.name',
        tdClass: 'boldText',
        filterOptions: {
          enabled: true,
          operator: 'like'
        }
      },
      {
        label: 'Sport',
        field: 'design.product.productCategory.name'
      },
      {
        label: 'Color',
        field: 'design.bodyColor.name'
      },
      {
        label: 'Date',
        field: 'createdAt',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDTHH:mm:ss.SSS', // expects 2018-03-16T05:29:18.123
        dateOutputFormat: 'MM/DD/YYYY'
      },
      {
        label: 'Qty',
        field: 'design.quantity'
      },
      {
        label: 'Gender',
        field: 'design.product.gender.name'
      },
      {
        label: 'Status',
        field: 'currentStatus',
        type: 'customCell'
      },
      {
        label: 'Actions',
        field: 'actions'
      }
    ]
  }

  imgSubmission = {
    center: true,
    blank: true,
    blankColor: '#bbb',
    height: 50
  }
}
</script>

<style lang="scss" scoped>
.orderNumberCell {
  align-items: center;
  display: flex;
  .imgSubmission {
    text-align: center;
    width: 100%;
  }
}
.submissionsContainer {
  /deep/ {
    table.vgt-table tbody tr td {
      vertical-align: middle;
    }
  }
}
#submitOrderButton {
  width: 234px;
}
</style>
